<template>
  <div class="main-loading">
    <div class="logo-wrapper">
      <img src="@/assets/main-logo.png" alt="taskban" />
      <span>تسک بان | TaskBan</span>
    </div>
  </div>
</template>

<script lang="ts"></script>

<style scoped lang="scss">
@import "src/assets/scss/variables";
@import "src/assets/scss/buttons";

.main-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  display: grid;
  place-items: center;
  background-color: var(--bg);

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100px;
      height: 100px;
      margin-bottom: 17px;
    }
    span {
      @include font-size(25px);
      color: var(--text-color);
    }
  }
}
</style>
